export default [
  {
    path: '/presupuestos-clasificadores',
    name: 'clasificadores',
    component: () => import('@/views/presupuestos/layouts/ClasificadorLayout.vue'),
  },
  {
    path: '/presupuestos',
    name: 'presupuestos',
    component: () => import('@/views/presupuestos/layouts/Presupuesto.vue'),
  },
  {
    path: '/presupuestos-ingresos-estimaciones',
    name: 'presupuestos-ingresos-estimaciones',
    component: () => import('@/views/presupuestos/layouts/PresupuestoEstimacionIngresos.vue'),
  },
  {
    path: '/presupuestos-unidades-medida',
    name: 'presupuestos-unidades-medida',
    component: () => import('@/views/presupuestos/layouts/UnidadesMedida.vue'),
  },
  {
    path: '/presupuestos-solicitud-transferencia-recursos',
    name: 'presupuestos-solicitud-transferencia-recursos',
    component: () => import('@/views/presupuestos/layouts/SolicitudTransferenciaRecursos.vue'),
  },
  {
    path: '/presupuestos-transferencia-entre-sedes',
    name: 'presupuestos-transferencia-entre-sedes',
    component: () => import('@/views/presupuestos/layouts/SolicitudEntreSedes.vue'),
  },
  {
    path: '/presupuestos-ejecucion-de-recursos',
    name: 'presupuestos-ejecucion-de-recursos',
    component: () => import('@/views/presupuestos/layouts/SolicitudTransferencias.vue'),
  },
  {
    path: '/presupuestos-reporte-desembolsos-por-item',
    name: 'reporte-desembolsos-por-item',
    component: () => import('@/views/presupuestos/layouts/ReporteEjecucionPresupuestaria.vue'),
  },
  {
    path: '/presupuestos-cuentas-pagadoras',
    name: 'presupuestos-cuentas-pagadoras',
    component: () => import('@/views/presupuestos/layouts/CuentasPagadoras.vue'),
  },
  {
    path: '/presupuestos-ingresos-proyectados',
    name: 'presupuestos-ingresos-proyectados',
    component: () => import('@/views/presupuestos/layouts/PresupuestoProyectadoIngresos.vue'),
  },
  {
    path: '/presupuestos-ingresos-reportes',
    name: 'presupuestos-ingresos-reportes',
    component: () => import('@/views/presupuestos/layouts/PresupuestoReporteIngresos.vue'),
  },
  {
    path: '/presupuestos-sedes',
    name: 'presupuestos-sedes',
    component: () => import('@/views/presupuestos/layouts/SedesPresupuestos.vue'),
  },
  {
    path: '/presupuestos-gestiones',
    name: 'gestiones',
    component: () => import('@/views/presupuestos/layouts/Gestiones.vue'),
  },
  {
    path: '/presupuestos-configuraciones-generales',
    name: 'configuraciones-generales',
    component: () => import('@/views/presupuestos/layouts/ConfiguracionesGenerales.vue'),
  },
  {
    path: '/presupuestos-grupos',
    name: 'grupos',
    component: () => import('@/views/presupuestos/layouts/GruposLayout.vue'),
  },
  {
    path: '/presupuestos-transferencia-entre-sedes-desembolsadas',
    name: 'transferencia-entre-sedes-desembolsadas',
    component: () => import('@/views/presupuestos/layouts/SolicitudEntreSedesDesembolsadas.vue'),
  },
  {
    path: '/presupuestos-consolidados',
    name: 'consolidados',
    component: () => import('@/views/presupuestos/layouts/PresupuestosConsolidadosLayout.vue'),
  },
];
